import { FormProvider } from 'react-hook-form';
import { useCreateGroupForm } from './hooks';
import { CreateGroupFormPresentation } from './presentations';

/**
 * グループ作成フォームのコンテナコンポーネント
 */
export const CreateGroupForm: React.FC = () => {
  const {
    state: { methods, isMutating },
    actions: { handleOnSubmit },
  } = useCreateGroupForm();

  return (
    <FormProvider {...methods}>
      <CreateGroupFormPresentation isButtonDisabled={isMutating} onSubmit={handleOnSubmit} />
    </FormProvider>
  );
};
